var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBounceArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 81,
    viewBox: "0 0 66 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.403 52.5267L48.0571 42.7634C49.2171 41.9417 49.918 40.6125 49.918 39.1867C49.918 35.5859 45.858 33.5075 42.9338 35.5859L33.0013 42.6667L23.0688 35.5859C20.1446 33.4834 16.0846 35.5859 16.0846 39.1867C16.0846 40.6125 16.7855 41.9659 17.9455 42.7875L31.5996 52.5509C32.4455 53.1309 33.5571 53.1309 34.403 52.5267Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.403 35.6097L48.0571 25.8705C49.2171 25.0247 49.918 23.6955 49.918 22.2697C49.918 18.6689 45.858 16.5664 42.9338 18.6689L33.0013 25.7497L23.0688 18.6689C20.1446 16.5664 16.0846 18.6689 16.0846 22.2697C16.0846 23.6955 16.7855 25.0489 17.9455 25.8705L31.5996 35.6339C32.4455 36.2139 33.5571 36.2139 34.403 35.6097Z",
    fill: "#1D1D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounceArrow);
export default __webpack_public_path__ + "static/media/bounceArrow.e52c0f6a537e86ef8f51dfa2caa614aa.svg";
export { ForwardRef as ReactComponent };